<template>
  <v-container>
    <v-row no-gutters align="center" justify="center">
      <v-col cols="5">
        <v-card
          class="margin-top-30"
          outlined>
            
          <v-card-title align="center" justify="center">
            Administrador de Órdenes
          </v-card-title>
          <v-card-subtitle align="center">
            por USA Transfers
          </v-card-subtitle>

          <v-divider class="mx-4"></v-divider>

          <v-skeleton-loader
            type="card"
            :loading="!dataLoaded">

            <v-card-text>
              <v-form>
                <v-row>
                  <v-col align="center">
                    <v-img
                      max-height="150"
                      max-width="150"
                      src="../assets/logo.png" />
                  </v-col>

                </v-row>
                <v-row
                  align="center"
                  no-gutters>

                  <v-text-field
                    ref="uidCode"
                    color="blue darken-2"
                    outlined
                    :label="nouid ? 'Sin Acceso' : 'Código de Acceso'"
                    dense
                    disabled
                    v-model="deviceUid"
                  ></v-text-field>

                  <v-btn
                    block
                    color="blue"
                    dark
                    :disabled="nouid"
                    @click="copyUid()">
                    Copiar Código
                  </v-btn>
                  
                </v-row>
              </v-form>
            </v-card-text>

          </v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { fauth, fremoteConfig, fdatabase, fmessaging } from '../plugins/firebase';
  import mixins from '../helpers/mixins';

  export default {
    name: 'Login',
    mixins: [mixins],
    data: () => ({
      deviceUid: '',
      dataLoaded: false,
      nouid: false
    }),
    mounted() {
      if (this.$route.params.uid) {
        this.deviceUid = this.$route.params.uid;
        this.handleCredentials();
      } else {
        this.nouid = true;
        this.dataLoaded = true;
      }
    },
    methods: {
      handleCredentials() {
        fremoteConfig
          .fetchAndActivate()
          .then(() => {
            const authdomain = fremoteConfig
              .getValue('authdomain')
              .asString();
            
              this.signIn(
                `${this.deviceUid}@${authdomain}`,
                this.deviceUid
              );
          });
      },
      async signIn(mail, password) {
        try {
          const auth = await fauth.signInWithEmailAndPassword(
            mail,
            password
          );
          const user = auth.user
          if (user) {
            const custom = await user.getIdTokenResult();

            this.$store
              .dispatch('signIn', {
                storeId: custom.claims.storeId,
                storePickUpCode: custom.claims.storePickUpCode,
                defaultShipping: custom.claims.defaultShipping,
                category: custom.claims.category
              })
              .then(() => {
                fdatabase
                  .ref(`Estatus/Categorias/${custom.claims.category}`)
                  .once('value')
                  .then((snapshot) => {
                    this.$store
                      .dispatch('handleStatus', {
                        statusArray: snapshot.val() 
                      })
                      .then(() => {
                        fmessaging
                          .getToken({
                            vapidKey: 'BPWmxH8Yip-BHezu5LpNKi68BhhHoIcPoPKZKELX3wW6adADYLPHRi5nrVfYsMWNMF4kT2UYOd0UM1Q4Lp-jhd8'
                          })
                          .then((currentToken) => {
                            this.$store
                              .dispatch('addToSession', { token: currentToken });
                            this.sendTokenCall('join', currentToken)
                              .then(() => {})
                              .catch(() => {});
                          })
                          .catch(() => {});

                        this.$router.replace('/');
                      });
                  });
              });
          } else {
            // eslint-disable-next-line no-throw-literal
            throw 'NO USER';
          }
        } catch (error) {
          //this.$swal.close();
          this.dataLoaded = true;
          //this.$swal.fire('Error!', 'Email o contraseña incorrectos', 'error');
        }
      },
      copyUid() {
        try {
          let uidCode = this.$refs.uidCode.$el.querySelector('input');
          uidCode.removeAttribute("disabled");
          uidCode.select();
          document.execCommand("copy");
          uidCode.setAttribute("disabled", "disabled");
          window.getSelection().removeAllRanges();

          this.$toast.success('Código copiado al portapapeles!');
        } catch (err) {
          this.$toast.error('Error al copiar el código');
        }
      },
    },
  }
</script>
<style scoped>
  .margin-top-30 {
    margin-top: 30%;
  }
  .v-card__title {
    display: block !important;
  }
</style>